import React from "react";
import { Box, Typography, IconButton, Button } from "@mui/material";
import { Refresh, Add } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface ReviewsHeaderProps {
  onRefresh: () => void;
  onAddReview: () => void;
}

const ReviewsHeader: React.FC<ReviewsHeaderProps> = ({ onRefresh, onAddReview }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 4, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Box>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            background: "linear-gradient(135deg, #ff0080 0%, #00d4ff 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {t("admin.sellerReviewsTitle", { defaultValue: "Seller Reviews" })}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t("admin.manageSellerRatings", { defaultValue: "Monitor and manage seller reliability and performance" })}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={onAddReview}
          sx={{
            background: "linear-gradient(135deg, #ff0080 0%, #00d4ff 100%)",
            fontWeight: 600,
          }}
        >
          {t("admin.sellerReviews.addReview", { defaultValue: "Add Review" })}
        </Button>
        <IconButton onClick={onRefresh} color="primary" sx={{ bgcolor: "rgba(0,212,255,0.1)" }}>
          <Refresh />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ReviewsHeader;